import { privateApi } from '../utils/axios';

export const getFriends = async () => {
  const response = await privateApi.get('/friends');
  return response.data;
};

export const sendFriendRequest = async (friendEmail) => {
  const response = await privateApi.post('/friends/send', { friendEmail });
  return response.data;
};

export const sendAppInvitation = async (friendEmail) => {
  const response = await privateApi.post('/friends/invite', { friendEmail });
  return response.data;
};

export const getPendingRequests = async () => {
  const response = await privateApi.get('/friends/pending');
  return response.data;
};

export const acceptFriendRequest = async (friendId) => {
  const response = await privateApi.post(`/friends/accept/${friendId}`);
  return response.data;
};

export const declineFriendRequest = async (friendId) => {
  const response = await privateApi.post(`/friends/decline/${friendId}`);
  return response.data;
};

export const removeFriend = async (friendId) => {
  const response = await privateApi.delete(`/friends/${friendId}`);
  return response.data;
};